'use strict';
import easeOutExpo from '../../../_js/_helper';

export default class Search {
    constructor() {


        $(document).ready(function () {
            var submitIcon = $('.searchbox-icon');
            var inputBox = $('.searchbox-input');
            var inputBoxInBody = $('.search-input-field');
            var searchBox = $('.searchbox');
            var searchBoxSubmit = $('.searchbox-submit');
            var searchInputIconInBody = $('.search-input-icon');
            var searchboxRecommendedMobile = $('nav .searchbox-recommended');
            var searchboxRecommendedDesktop = $('.searchbox-wrapper .searchbox-recommended');
            var closeRecommended = $('.close-recommended-search');
            var isOpen = false;

            function submit() {
                var searchItem = inputBox.val();
                // var getUrl = window.location;
                // var baseUrl = getUrl .protocol + "//" + getUrl.host + "/" + getUrl.pathname.split('/')[1];
                var fullSearchUrl = $('.searchbox').data('searchurl');
                var searchUrl = fullSearchUrl + searchItem;
                inputBox.val('');
                window.location.href = searchUrl;
            }

            function submitInBody(e) {
                var searchItem = $(e.target).siblings('.search-input-field').val();
                if (searchItem === '') {
                    return false;
                }
                // var getUrl = window.location;
                // var baseUrl = getUrl .protocol + "//" + getUrl.host + "/" + getUrl.pathname.split('/')[1];
                var fullSearchUrl = $('.searchbox').data('searchurl');
                var searchUrl = fullSearchUrl + searchItem;
                inputBox.val('');
                window.location.href = searchUrl;
            }
            searchInputIconInBody.click(function (e) {
                submitInBody(e);
            });
            
            searchInputIconInBody.keypress(function (e) {
                if (e.keyCode == 13 || e.which == 13) {
                    submitInBody(e);
                }
            });

            inputBoxInBody.keypress(function (e) {
                if(e.keyCode == 13 || e.which == 13)
                {
                    searchInputIconInBody.trigger('click');
                }
            });

            searchBoxSubmit.click(function (e) {
                submit();
            });

            inputBox.keypress(function (e) {
                if (e.keyCode == 13) {
                    submit();
                }
            });

            if ($(window).width() > 980) {
                submitIcon.click(function (e) {
                    e.preventDefault();
                    if (isOpen == false) {
                        searchBox.addClass('searchbox-open');
                        searchboxRecommendedDesktop.slideDown(easeOutExpo);
                        inputBox.focus();
                        isOpen = true;
                    } else {
                        searchBox.removeClass('searchbox-open');
                        searchboxRecommendedDesktop.slideUp(easeOutExpo);
                        inputBox.focusout();
                        isOpen = false;
                    }
                });
            }

            closeRecommended.click(function (e) {
                searchboxRecommendedMobile.slideUp(easeOutExpo);
            });

            inputBoxInBody.focus(function () {
                searchboxRecommendedMobile.slideDown(easeOutExpo);
            });

            inputBoxInBody.blur(function () {
                searchboxRecommendedMobile.slideUp(easeOutExpo);
            });

            submitIcon.mouseup(function () {
                return false;
            });
            searchBox.mouseup(function () {
                return false;
            });
            $(document).mouseup(function () {
                if (isOpen == true) {
                    $('.searchbox-icon').css('display', 'block');
                    submitIcon.click();
                }
            });
        });
        window.buttonUp = function () {
            var inputVal = $('.searchbox-input').val();
            inputVal = $.trim(inputVal).length;
            if (inputVal !== 0) {
                // $('.searchbox-icon').css('display', 'none');
                $('.searchbox-submit').addClass('submit-active');
                $('.searchbox-submit').attr('tabindex', '0');
            } else {
                $('.searchbox-input').val('');
                $('.searchbox-submit').removeClass('submit-active');
                // $('.searchbox-icon').css('display', 'block');
            }
        };
    }
}
